<div class="indicator-question">
    <div id="question" class="card">
        <div class="row">
            <div class="col-sm-7">
                <h6>
                    {{'forms.common.' + question.key | translate}}
                </h6>
            </div>
            <br />
            <div class="col-sm-4">
                <input type="number" min="0" class="form-control" [(ngModel)]="question.answer" [disabled]="viewOnly"
                    (keyup)="checkValue($event)" />
            </div>
        </div>

        <div class="questInfo" *ngIf="question.description"
            (click)="showDialog('forms.common.' + question.description)">
            <i class="fa fa-info"></i>
        </div>
    </div>
</div>